if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('on:debounced-resize', this.resizeHandler);

      if (this.resizeInitHandler) {
        window.removeEventListener('on:debounced-resize', this.resizeInitHandler);
      }

      if (this.zoomInitHandler) {
        window.removeEventListener('on:debounced-resize', this.zoomInitHandler);
      }
    }

    init() {
      this.section = this.closest('.js-product');
      this.noSelectedVariant = this.hasAttribute('data-no-selected-variant');
      this.mediaGroupingEnabled = this.hasAttribute('data-media-grouping-enabled')
        && this.getMediaGroupData();
      this.stackedScroll = this.dataset.stackedScroll;
      this.stackedUnderline = this.dataset.stackedUnderline === 'true' && !this.mediaGroupingEnabled;
      this.isFeatured = this.dataset.isFeatured === 'true';
      this.viewer = this.querySelector('.media-viewer');
      this.thumbs = this.querySelector('.media-thumbs');
      this.thumbsItems = this.querySelectorAll('.media-thumbs__item');
      this.controls = this.querySelector('.media-ctrl');
      this.prevBtn = this.querySelector('.media-ctrl__btn[name="prev"]');
      this.nextBtn = this.querySelector('.media-ctrl__btn[name="next"]');
      this.counterCurrent = this.querySelector('.media-ctrl__current-item');
      this.counterTotal = this.querySelector('.media-ctrl__total-items');
      this.liveRegion = this.querySelector('.media-gallery__status');
      this.zoomLinks = this.querySelectorAll('.js-zoom-link');
      this.loadingSpinner = this.querySelector('.loading-spinner');
      this.xrButton = this.querySelector('.media-xr-button');

      if (this.hasAttribute('data-zoom-enabled')) {
        this.galleryModal = this.querySelector('.js-media-zoom-template').content.firstElementChild.cloneNode(true);
      }

      // Umschalter 3D / 2D. Nur im stacked-Layout ab md: darunter ist die
      // Galerie ein Scroll-Snap-Slider, in dem das Modell schlicht Folie 1 ist
      // und first-active gar keine Wirkung hat - dort gibt es keine grosse
      // Kachel, die man umschalten koennte. Die Leiste startet im Markup mit
      // hidden und wird erst hier freigegeben.
      this.lbrgtUmschalter = this.querySelector('.lbrgt-ansicht');
      if (this.lbrgtUmschalter && this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        // lbrgtWunsch ist die zuletzt bewusst getroffene Wahl, lbrgtModus der
        // Zustand, der gerade wirklich gilt. Die beiden laufen auseinander,
        // sobald eine Farbe gar kein Modell hat.
        this.lbrgtWunsch = '2d';
        this.lbrgtModus = '2d';
        this.lbrgtUmschalter.addEventListener('click', (evt) => {
          const btn = evt.target.closest('[data-lbrgt-ansicht]');
          if (!btn) return;
          this.lbrgtWunsch = btn.dataset.lbrgtAnsicht;
          this.lbrgtAnsichtSetzen(this.lbrgtWunsch);
        });
      } else {
        // Kein Umschalter: alles laeuft wie bisher.
        this.lbrgtUmschalter = null;
      }

      // Bewusst NACH dem Umschalter: setActiveMediaGroup aktiviert bei einem
      // Gruppenwechsel items[0], und das ist die Modellkachel. Die Pruefung dort
      // braucht lbrgtUmschalter und lbrgtModus - stuenden sie noch auf
      // undefined, wuerde die Modelldatei schon beim Seitenaufbau geladen.
      if (this.mediaGroupingEnabled && !this.noSelectedVariant) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        this.resizeInitHandler = this.resizeInitHandler || this.initGallery.bind(this);
        window.addEventListener('on:debounced-resize', this.resizeInitHandler);
        this.setVisibleItems();
        this.previousMediaItem = this.querySelector('.media-viewer__item.is-current-variant');
        setTimeout(() => {
          this.customSetActiveMedia(this.lbrgtLeadMedia(this.previousMediaItem), this.stackedScroll === 'always');
          this.lbrgtAnsichtSetzen(this.lbrgtWunsch || '2d');
        }, 200);
      } else {
        this.initGallery();
      }

      if (this.zoomLinks) {
        if (this.dataset.zoomTrigger === 'hover') {
          this.triggerZoomInit();
        } else {
          this.zoomLinks.forEach((zoomLink) => {
            zoomLink.addEventListener('click', (evt) => {
              this.triggerZoomInit();
              evt.preventDefault();
            });
          });
        }
      }

      this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
    }

    triggerZoomInit() {
      this.zoomInitHandler = this.zoomInitHandler || this.initZoom.bind(this);
      this.zoomEventListener = this.zoomEventListener || this.handleZoomMouseMove.bind(this);
      window.addEventListener('on:debounced-resize', this.zoomInitHandler);
      this.initZoom();
      this.zoomLinks.forEach((zoomLink) => {
        zoomLink.addEventListener('click', (evt) => {
          evt.preventDefault();
        });
      });
    }

    /**
     * Handle a change in variant on the page.
     * @param {Event} evt - variant change event dispatched by variant-picker
     */
    onVariantChange(evt) {
      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }

      if (evt.detail.variant && evt.detail.variant.featured_media) {
        const variantMedia = this.viewer.querySelector(
          `[data-media-id="${evt.detail.variant.featured_media.id}"]`
        );
        if (variantMedia) {
          this.customSetActiveMedia(this.lbrgtLeadMedia(variantMedia), true);
        }
      }

      // Nach dem Farbwechsel gilt der gewaehlte Modus weiter. Ohne diesen Aufruf
      // faellt der Nutzer bei jedem Farbklick zurueck auf 3D, und die Kacheln der
      // neuen Farbe blieben in dem Sichtbarkeitszustand, den die alte hatte.
      this.lbrgtAnsichtSetzen(this.lbrgtWunsch || '2d');
    }

    /**
     * Gets the media group from currently selected variant options.
     * @returns {?object}
     */
    getMediaGroupFromOptionSelectors() {
      const optionSelectors = this.section.querySelectorAll('.option-selector');
      if (optionSelectors.length > this.getMediaGroupData().groupOptionIndex) {
        const selector = optionSelectors[this.getMediaGroupData().groupOptionIndex];
        if (selector.dataset.selectorType === 'dropdown') {
          // Ist die Farbe komplett ausverkauft, fehlt der Knopf bzw. es ist kein
          // Radio angehakt. Ohne diese Pruefung wirft der Zugriff auf .value bzw.
          // .textContent, setActiveMediaGroup laeuft nie und die Galerie zeigt
          // alle Bilder aller Farben gleichzeitig.
          const knopf = selector.querySelector('.custom-select__btn');
          return knopf ? knopf.textContent.trim() : null;
        }
        const angehakt = selector.querySelector('input:checked');
        return angehakt ? angehakt.value : null;
      }
      return null;
    }

    /**
     * Gets the variant media associations for a product.
     * @returns {?object}
     */
    getMediaGroupData() {
      if (typeof this.variantMediaData === 'undefined') {
        const dataEl = this.querySelector('.js-data-variant-media');
        this.variantMediaData = dataEl ? JSON.parse(dataEl.textContent) : false;
      }

      return this.variantMediaData;
    }

    /**
     * Gets an object mapping media to groups, and the reverse
     * @returns {?object}
     */
    getMediaGroupMap() {
      if (!this.mediaGroupMap) {
        this.mediaGroupMap = {
          groups: {}
        };

        // set up grouping
        const variantMediaData = this.getMediaGroupData();
        let currentMediaOptionName = false;
        this.viewerItems = this.querySelectorAll('.media-viewer__item');
        this.viewerItems.forEach((item) => {
          for (let i = 0; i < variantMediaData.variantMedia.length; i += 1) {
            if (parseInt(item.dataset.mediaId, 10) === variantMediaData.variantMedia[i].mediaId) {
              if (currentMediaOptionName !== variantMediaData.variantMedia[i].option) {
                currentMediaOptionName = variantMediaData.variantMedia[i].option;
              }
            }
          }
          if (currentMediaOptionName) {
            if (!this.mediaGroupMap.groups[currentMediaOptionName]) {
              this.mediaGroupMap.groups[currentMediaOptionName] = {
                name: currentMediaOptionName,
                items: []
              };
            }
            const groupItem = { main: item };
            if (this.thumbs) {
              groupItem.thumb = this.thumbs.querySelector(
                `[data-media-id="${item.dataset.mediaId}"].media-thumbs__item`
              );
            }
            this.mediaGroupMap.groups[currentMediaOptionName].items.push(groupItem);
          }
        });

        // add helper
        this.mediaGroupMap.groupFromItem = (item) => {
          const groups = Object.keys(this.mediaGroupMap.groups);
          for (let i = 0; i < groups; i += 1) {
            const group = groups[i];
            for (let j = 0; j < this.mediaGroupMap.groups[group].items.length; j += 1) {
              if (this.mediaGroupMap.groups[group].items[j] === item) {
                return this.mediaGroupMap.groups[group];
              }
            }
          }
          return this.mediaGroupMap.groups[Object.keys(this.mediaGroupMap.groups)[0]];
        };
      }

      return this.mediaGroupMap;
    }

    /**
     * Show only images associated to the current variant
     * @param {string} groupName - optional - Group to show (uses this.currentItem if empty)
     */
    setActiveMediaGroup(groupName) {
      const mediaGroupMap = this.getMediaGroupMap();
      const selectedGroup = groupName
        ? mediaGroupMap.groups[groupName]
        : mediaGroupMap.groupFromItem(this.currentItem);

      if (selectedGroup) {
        if (this.currentGroup !== selectedGroup) {
          this.currentGroup = selectedGroup;
          this.viewerItems.forEach((item) => {
            item.style.display = 'none';
            item.classList.remove('media-viewer__item--single');
          });
          this.thumbsItems.forEach((item) => {
            item.style.display = 'none';
          });

          let currentItemIsVisible = false;
          selectedGroup.items.forEach((item) => {
            item.main.style.display = '';
            if (item.thumb) {
              item.thumb.style.display = '';
            }
            if (item.main === this.currentItem) {
              currentItemIsVisible = true;
            }
          });
          this.setVisibleItems();

          // If current item is not in this group, set it as the active item
          if (!currentItemIsVisible) {
            // items[0] ist die Modellkachel, weil die 3D-Modelle im Markup vor
            // den Bildern stehen. Solange 2D der gewaehlte Zustand ist, darf sie
            // hier nicht aktiv werden: customSetActiveMedia ruft
            // lbrgtModellStarten, und das laedt die Modelldatei - beim High
            // Performance 4,9 MB - obwohl niemand auf 3D geschaltet hat.
            let ziel = selectedGroup.items[0].main;
            if (this.lbrgtUmschalter && this.lbrgtModus !== '3d') {
              const ohneModell = selectedGroup.items.find((i) => i.main.dataset.mediaType !== 'model');
              if (ohneModell) ziel = ohneModell.main;
            }
            this.customSetActiveMedia(ziel, true);
          }

          // Handle single images on stacked view
          if (selectedGroup.items.length === 1) {
            selectedGroup.items[0].main.classList.add('media-viewer__item--single');
          }
        }
      } else {
        this.viewerItems.forEach((item) => {
          item.style.display = '';
        });
        this.thumbsItems.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    /**
     * Initialises the media gallery slider and associated controls.
     */
    initGallery() {
      this.setVisibleItems();
      if (this.visibleItems.length <= 1) return;

      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
      this.currentIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);
      this.currentItem = this.visibleItems[this.currentIndex];
      this.addListeners();

      if (this.thumbs && this.currentItem) {
        this.currentThumb = this.thumbs.querySelector(
          `[data-media-id="${this.currentItem.dataset.mediaId}"]`
        );
      }

      if (!this.isFeatured && document.hasFocus()) {
        // Eager load the slider images for smooth UX
        this.viewer.querySelectorAll('.product-image[loading="lazy"]').forEach((img, index) => {
          setTimeout(() => {
            img.loading = 'eager';
          }, 500 * (index + 1));
        });
      }

      const currentItem = this.querySelector('.media-viewer__item.is-current-variant');
      this.customSetActiveMedia(currentItem, true);
    }

    addListeners() {
      this.viewer.addEventListener('scroll', this.handleScroll.bind(this));
      if (this.controls) this.controls.addEventListener('click', this.handleNavClick.bind(this));
      if (this.thumbs) this.thumbs.addEventListener('click', this.handleThumbClick.bind(this));
      this.resizeHandler = this.resizeHandler || this.handleResize.bind(this);
      window.addEventListener('on:debounced-resize', this.resizeHandler);
    }

    /**
     * Initialized the zoom on hover for desktop
     */
    initZoom() {
      this.zoomLinks.forEach((el) => {
        const zoomWidth = Number(el.querySelector('.zoom-image').dataset.originalWidth || 0);
        const imageWidth = el.querySelector('.product-image').getBoundingClientRect().width;
        if (theme.mediaMatches.md && ((zoomWidth - 75) > (imageWidth))) {
          el.addEventListener('mousemove', this.zoomEventListener);
          el.classList.remove('pointer-events-none');
        } else {
          el.removeEventListener('mousemove', this.zoomEventListener);
          el.classList.add('pointer-events-none');
        }
      });
    }

    /**
     * Handles mouse move over a zoomable image
     * @param {?object} evt - Event object.
     */
    handleZoomMouseMove(evt) {
      if (this.hasAttribute('data-zoom-enabled') && !this.dataset.zoomTrigger && !evt.target.closest('.gallery-zoom-modal')) {
        return;
      }

      const hoverElem = evt.currentTarget;
      const zoomImage = hoverElem.querySelector('.js-zoom-image');

      // Download the zoom image if necessary
      if (zoomImage.dataset.src) {
        this.loadingSpinner.classList.remove('loading-spinner--out');

        const img = new Image();
        img.src = zoomImage.dataset.src;
        img.onload = () => {
          zoomImage.src = img.src;
          hoverElem.classList.remove('media--zoom-not-loaded');
          this.loadingSpinner.classList.add('loading-spinner--out');
        };
        zoomImage.removeAttribute('data-src');
      }

      try {
        const offsetX = evt.offsetX ? evt.offsetX : evt.touches[0].pageX;
        const offsetY = evt.offsetY ? evt.offsetY : evt.touches[0].pageY;
        const x = (offsetX / zoomImage.offsetWidth) * 100;
        const y = (offsetY / zoomImage.offsetHeight) * 100;
        zoomImage.style.objectPosition = `${x}% ${y}%`;
      } catch (err) {
        // Fail silently
      }
    }

    /**
     * Handles 'scroll' events on the main media container.
     */
    handleScroll() {
      const newIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);

      if (newIndex !== this.currentIndex) {
        const viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;

        // If scroll wasn't caused by a resize event, update the active media.
        if (viewerItemOffset === this.viewerItemOffset) {
          this.customSetActiveMedia(this.visibleItems[newIndex], false);
        }
      }
    }

    /**
     * Handles 'click' events on the controls container.
     * @param {object} evt - Event object.
     */
    handleNavClick(evt) {
      if (!evt.target.matches('.media-ctrl__btn')) return;

      const itemToShow = evt.target === this.nextBtn
        ? this.visibleItems[this.currentIndex + 1]
        : this.visibleItems[this.currentIndex - 1];

      this.viewer.scrollTo({ left: itemToShow.offsetLeft, behavior: 'smooth' });
    }

    /**
     * Handles 'click' events on the thumbnails container.
     * @param {object} evt - Event object.
     */
    handleThumbClick(evt) {
      const thumb = evt.target.closest('[data-media-id]');
      if (!thumb) return;

      const itemToShow = this.querySelector(`[data-media-id="${thumb.dataset.mediaId}"]`);
      this.customSetActiveMedia(itemToShow);

      MediaGallery.playActiveMedia(itemToShow);
    }

    /**
     * Handles debounced 'resize' events on the window.
     */
    handleResize() {
      // Reset distance from leading edge of one slide to the next.
      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;

      if (this.thumbs && this.currentThumb) {
        this.checkThumbVisibilty(this.currentThumb);
      }
    }

    /**
     * Stub for variant-picker calls. Listening to change event instead.
     */
    // eslint-disable-next-line class-methods-use-this
    setActiveMedia() {}

    /**
     * Liefert das Medium, das fuer die aktuelle Farbe gross stehen soll.
     * Hat die Farbe ein 3D-Modell, steht es an Position 0 der Gruppe und
     * gewinnt - sonst bleibt es beim uebergebenen Variantenbild.
     * @param {Element} fallback - Medium, das ohne Modell gross stehen soll.
     * @returns {Element}
     */
    lbrgtLeadMedia(fallback) {
      // Nur solange 3D gewaehlt ist. Vorher gewann das Modell immer, auch beim
      // Farbwechsel - seit 2D der Standard ist, wuerde das die Datei laden,
      // ohne dass jemand danach gefragt hat.
      if (this.lbrgtUmschalter && this.lbrgtModus !== '3d') return fallback;
      const gruppe = this.currentGroup;
      const erstes = gruppe && gruppe.items && gruppe.items[0] && gruppe.items[0].main;
      if (erstes && erstes.dataset.mediaType === 'model') return erstes;
      return fallback;
    }

    /**
     * Startet ein 3D-Modell, sobald es das grosse Bild wird - ohne Klick.
     *
     * DeferredMedia haengt im Konstruktor einen IntersectionObserver an, wenn kein
     * .js-load-media im Markup steht. Der greift hier aber nicht: die Galerie wird
     * bei jedem Variantenwechsel neu aufgebaut, und der beobachtete Knoten ist dann
     * abgehaengt - gemessen: null Aufrufe des Beobachters, auch nach mehreren
     * Sekunden im Sichtfeld.
     *
     * Deshalb wird hier direkt geladen, und zwar genau dann, wenn das Modell zum
     * aktiven Medium wird. focus und pause stehen auf false: der Fokus soll nicht
     * springen und andere Medien sollen nicht angehalten werden.
     *
     * @param {Element} mediaItem - Das gerade aktive Medium.
     */
    lbrgtModellStarten(mediaItem) {
      const modell = mediaItem.querySelector('product-model:not([loaded])');
      if (modell && typeof modell.loadContent === 'function') {
        modell.loadContent(false, false, 'auto');
        this.lbrgtModellDarstellung(modell);
        return;
      }

      // Schon geladenes Modell wieder freigeben.
      //
      // customSetActiveMedia ruft ganz zu Beginn window.pauseAllMedia(), und
      // das laeuft in assets/main.js:254-260 ueber ALLE product-model - auch
      // ueber das, auf das gerade umgeschaltet wird. pause() haengt dem
      // model-viewer wieder shopify-model-viewer-ui__disabled an und blendet
      // Shopifys Startknopf ein.
      //
      // Beim Wechsel von 2D auf 3D sah man deshalb den Knopf kurz aufblitzen,
      // und das Modell liess sich erst nach einem weiteren Klick drehen. Hier
      // wird es direkt wieder freigegeben - dieselbe Stelle, an der auch
      // product-model.js nach dem ersten Laden play() ruft.
      const geladen = mediaItem.querySelector('product-model[loaded]');
      if (geladen && geladen.modelViewerUI && typeof geladen.modelViewerUI.play === 'function') {
        geladen.modelViewerUI.play();
      }
    }

    /**
     * Beleuchtung und Schatten des 3D-Modells.
     *
     * Shopify erzeugt das model-viewer-Element ueber den media_tag-Filter und
     * setzt dabei keines dieser Attribute. Die Voreinstellungen von model-viewer
     * sind: kein Schlagschatten (shadow-intensity 0) und eine Umgebung, die von
     * vorne beleuchtet - dreht man den Schuh, ist die Rueckseite dunkel.
     *
     * Im Altshop sah es anders aus: gleichmaessig ausgeleuchtet, mit Schatten
     * unter dem Schuh. Genau das stellen die beiden Attribute her.
     *
     * neutral ist ein von model-viewer mitgeliefertes Umgebungslicht, das von
     * allen Seiten gleichmaessig aufhellt - keine zusaetzliche Datei noetig.
     *
     * @param {Element} modell - Das product-model-Element.
     */
    lbrgtModellDarstellung(modell) {
      const viewer = modell.querySelector('model-viewer');
      if (!viewer) return;
      viewer.setAttribute('environment-image', 'neutral');
      viewer.setAttribute('shadow-intensity', '1');
      viewer.setAttribute('shadow-softness', '0.75');

      // Innenabstand im quadratischen Slot.
      //
      // Shopify setzt keinerlei Kameraattribute, model-viewer rahmt das Modell
      // deshalb randlos ein: gemessen fuellt der Schuh 99,6% der Kachelbreite.
      // Auf den Produktfotos daneben sind es 74,3% - das 3D wirkt dadurch rund
      // ein Drittel groesser als dasselbe Modell auf dem Foto.
      //
      // Prozentwerte im camera-orbit rechnen gegen die idealCameraDistance:
      // 100% = randlos, 135% = 74,2% Kachelbreite, also praktisch die Optik der
      // Fotos. 75deg ist der heutige Default (gemessen 1,309 rad) - die
      // Blickrichtung bleibt also, nur die Distanz aendert sich.
      //
      // max-camera-orbit MUSS mit hoch: der Default klemmt den Radius auf
      // 'auto' (= 105%), sonst verpufft der Wert wirkungslos.
      viewer.setAttribute('max-camera-orbit', 'auto auto 400%');
      viewer.setAttribute('camera-orbit', '0deg 75deg 135%');

      // Waehrend das Modell laedt, zeigt model-viewer sein eigenes Poster - und
      // das ist das von Shopify aus der Datei erzeugte Vorschaubild. Gemessen
      // an allen vier Ecken: reines Weiss (rgb 255,255,255), ein JPEG ohne
      // Transparenz. Genau dieses Weiss sah man beim Laden.
      //
      // Ohne poster-Attribut bleibt die Flaeche durchsichtig, und der Grund der
      // Kachel (#f1f1f1) steht auch waehrend des Ladens. Der Ladebalken von
      // model-viewer bleibt davon unberuehrt.
      viewer.removeAttribute('poster');
    }

    /**
     * Das 3D-Modell der aktuellen Farbe - oder null, wenn die Farbe keines hat.
     * @returns {?Element}
     */
    lbrgtModellMedia() {
      const gruppe = this.currentGroup;
      if (!gruppe || !gruppe.items) return null;
      const treffer = gruppe.items.find((i) => i.main.dataset.mediaType === 'model');
      return treffer ? treffer.main : null;
    }

    /**
     * Das Medium fuer "2D Ansicht": das erste Nicht-Modell der aktuellen Farbe.
     * @returns {?Element}
     */
    lbrgt2dMedia() {
      const gruppe = this.currentGroup;
      if (!gruppe || !gruppe.items) {
        return this.viewer.querySelector('.media-viewer__item:not([data-media-type="model"])');
      }
      const treffer = gruppe.items.find((i) => i.main.dataset.mediaType !== 'model');
      return treffer ? treffer.main : null;
    }

    /**
     * Schaltet die grosse Kachel zwischen Modell und erstem Produktbild um.
     *
     * Beide Kacheln bleiben an ihrer Stelle im DOM - umgeschaltet wird nur die
     * Sichtbarkeit. Das ist Absicht: die Farbgruppierung vererbt die Farbe ueber
     * die DOM-Reihenfolge an die jeweils naechste Kachel (getMediaGroupMap),
     * ausserdem haengen Folienbreite, Zaehler und Pfeile an der Position in
     * visibleItems. Eine Umsortierung wuerde beides verschieben.
     *
     * Bewusst ueber eine Klasse und nicht ueber style.display: setActiveMediaGroup
     * setzt beim Farbwechsel style.display fuer alle Gruppenmitglieder zurueck
     * und wuerde einen Inline-Wert ueberschreiben.
     *
     * @param {string} modus - '3d' oder '2d'.
     */
    lbrgtAnsichtSetzen(modus) {
      if (!this.lbrgtUmschalter) return;

      // Erst alles aufdecken: nach einem Farbwechsel koennen Kacheln der alten
      // Farbe noch ausgeblendet sein.
      this.viewer.querySelectorAll('.lbrgt-ansicht-aus').forEach((el) => {
        el.classList.remove('lbrgt-ansicht-aus');
      });

      const modell = this.lbrgtModellMedia();
      const bild = this.lbrgt2dMedia();

      // Farbe ohne Modell oder ohne Bild: nichts umzuschalten, Leiste weg.
      // this.lbrgtWunsch bleibt dabei bewusst stehen - sonst haette ein Umweg
      // ueber eine Farbe ohne 3D den Nutzer dauerhaft auf 2D gestellt, obwohl
      // er das nie gewaehlt hat.
      if (!modell || !bild) {
        this.lbrgtModus = '2d';
        this.lbrgtUmschalterAktualisieren(false);
        return;
      }

      this.lbrgtModus = modus === '2d' ? '2d' : '3d';
      const ziel = this.lbrgtModus === '3d' ? modell : bild;
      const anderes = this.lbrgtModus === '3d' ? bild : modell;

      anderes.classList.add('lbrgt-ansicht-aus');
      this.setVisibleItems();
      this.customSetActiveMedia(ziel, false);
      this.lbrgtUmschalterAktualisieren(true);
    }

    /**
     * Bringt die Leiste auf den Stand von this.lbrgtModus.
     * @param {boolean} sichtbar - Ob die Farbe ueberhaupt umschaltbar ist.
     */
    lbrgtUmschalterAktualisieren(sichtbar) {
      if (!this.lbrgtUmschalter) return;
      this.lbrgtUmschalter.hidden = !sichtbar;
      this.lbrgtUmschalter.querySelectorAll('[data-lbrgt-ansicht]').forEach((btn) => {
        const an = btn.dataset.lbrgtAnsicht === this.lbrgtModus;
        btn.classList.toggle('is-active', an);
        btn.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
    }

    /**
     * Sets the active media item.
     * @param {Element} mediaItem - Media element to set as active.
     * @param {boolean} [scrollToItem=true] - Scroll to the active media item.
     */
    customSetActiveMedia(mediaItem, scrollToItem = true) {
      if (mediaItem === this.currentItem) return;
      window.pauseAllMedia(this);
      this.currentItem = mediaItem;
      //for first variantimage
      this.viewer.querySelectorAll('.media-viewer__item').forEach(item => {
        item.classList.remove('first-active');
      });
 
      if (mediaItem) {
        mediaItem.classList.add('first-active');
        this.lbrgtModellStarten(mediaItem);
      }
      this.currentIndex = this.visibleItems.indexOf(this.currentItem);

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        // Update the active class and scroll to the active media
        if (this.stackedUnderline) {
          if (this.previousMediaItem) this.previousMediaItem.classList.remove('is-active');
          mediaItem.classList.add('is-active');
          this.previousMediaItem = mediaItem;
        }

        if (this.stackedScroll !== 'never') {
          const y = mediaItem.getBoundingClientRect().top
            + document.documentElement.scrollTop - 150;

          // If the element is far enough away to scroll to it
          if (Math.abs(y - document.documentElement.scrollTop) > 300) {
            window.scrollTo({
              top: y < 100 ? 0 : y,
              behavior: 'smooth'
            });
          }
        }
        return;
      }

      if (scrollToItem) this.viewer.scrollTo({ left: this.currentItem.offsetLeft });
      if (this.thumbs) this.setActiveThumb();

      if (this.controls) {
        if (this.prevBtn) {
          this.prevBtn.disabled = this.currentIndex === 0;
        }

        if (this.nextBtn) {
          this.nextBtn.disabled = this.currentIndex === this.visibleItems.length - 1;
        }

        if (this.counterCurrent) {
          this.counterCurrent.textContent = this.currentIndex + 1;
        }
      }

      this.announceLiveRegion(this.currentItem, this.currentIndex + 1);

      if (this.xrButton && mediaItem.dataset.mediaType === 'model') {
        this.xrButton.dataset.shopifyModel3dId = mediaItem.dataset.mediaId;
      }
    }

    /**
     * Sets the active thumbnail.
     */
    setActiveThumb() {
      this.currentThumb = this.thumbs.querySelector(
        `[data-media-id="${this.currentItem.dataset.mediaId}"]`
      );
      const btn = this.currentThumb.querySelector('button');

      this.thumbs.querySelectorAll('.media-thumbs__btn').forEach((el) => {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-current', 'true');
      this.checkThumbVisibilty(this.currentThumb);
    }

    /**
     * Creates an array of the visible media items.
     */
    setVisibleItems() {
      this.viewerItems = this.querySelectorAll('.media-viewer__item');
      this.visibleItems = Array.from(this.viewerItems).filter((el) => el.clientWidth > 0);
      if (this.counterTotal) {
        this.counterTotal.textContent = this.visibleItems.length;
      }
    }

    /**
     * Ensures a thumbnail is in the visible area of the slider.
     * @param {Element} thumb - Thumb item element.
     */
    checkThumbVisibilty(thumb) {
      const scrollPos = this.thumbs.scrollLeft;
      const lastVisibleThumbOffset = this.thumbs.clientWidth + scrollPos;
      const thumbOffset = thumb.offsetLeft;

      if (thumbOffset + thumb.clientWidth > lastVisibleThumbOffset || thumbOffset < scrollPos) {
        this.thumbs.scrollTo({ left: thumbOffset, behavior: 'smooth' });
      }
    }

    /**
     * Updates the media gallery status.
     * @param {Element} mediaItem - Active media element.
     * @param {number} index - Active media index.
     */
    announceLiveRegion(mediaItem, index) {
      const image = mediaItem.querySelector('.media-viewer img');
      if (!image) return;

      this.liveRegion.setAttribute('aria-hidden', 'false');
      this.liveRegion.innerHTML = theme.strings.imageAvailable.replace('[index]', index);

      setTimeout(() => {
        this.liveRegion.setAttribute('aria-hidden', 'true');
      }, 2000);
    }

    /**
     * Loads the deferred media for the active item.
     * @param {Element} mediaItem - Active media element.
     */
    static playActiveMedia(mediaItem) {
      window.pauseAllMedia();
      const deferredMedia = mediaItem.querySelector('deferred-media');
      if (deferredMedia) deferredMedia.loadContent();
    }
  }

  customElements.define('media-gallery', MediaGallery);
}
